import { ClassValue } from "clsx";
import { cn } from "@drpcrd/utils/shared";
import { ReactNode } from "react";
import { CreatorPageContentWrapper } from "./creator-page-content-wrapper";

type Props = {
  className?: ClassValue;
  children?: ReactNode;
  contentClassName?: ClassValue;
  /**
   * If true, removes the default max-width and padding wrapper.
   * Use this when you need to mix full-width elements with constrained elements.
   * You can use `CreatorPageContentWrapper` manually for the constrained parts.
   */
  disableContentWrapper?: boolean;
};

/**
 * Layout container for creator pages with standardized spacing and scrolling.
 *
 * Provides 16px horizontal padding to prevent shadow clipping, consistent scrollbar positioning,
 * and 16px bottom padding for bottom navigation clearance. Centers content with a max width of 54 units.
 */
export const CreatorPageLayout = ({
  className,
  children,
  contentClassName,
  disableContentWrapper,
}: Props) => (
  <div
    className={cn(
      "relative flex h-full w-full grow flex-col items-center overflow-y-auto scroll-smooth",
      className,
    )}
  >
    {/* Target max-width is 54un, so we set max-w-56 and use px-2 (2un each side) to achieve the desired 54-unit content width with proper spacing */}
    {disableContentWrapper ? (
      children
    ) : (
      <CreatorPageContentWrapper className={contentClassName}>
        {children}
      </CreatorPageContentWrapper>
    )}
  </div>
);
